module.exports = __webpack_public_path__ + "img/send.589a4a80.svg";